import * as core from '../../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'dashboard',
    content: {
      root: {
        elements: [
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'overview.report.card',
                        },
                      },
                    },
                    span: 4,
                  },
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'type.bar.chart',
                        },
                      },
                    },
                    span: 4,
                  },
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'change.impacts.by.validation.status',
                        },
                      },
                    },
                    span: 4,
                  },
                ],
              },
            },
            height: 400,
          },
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'change.impacts.by.department',
                        },
                      },
                    },
                    span: 12,
                  },
                ],
              },
            },
            height: 400,
          },
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'anticipated.response.of.change',
                        },
                      },
                    },
                    span: 6,
                  },
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'degree.of.change.bar.chart',
                        },
                      },
                    },
                    span: 6,
                  },
                ],
              },
            },
            height: 400,
          },
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'anticipated.response.of.change.by.department',
                        },
                      },
                    },
                    span: 12,
                  },
                ],
              },
            },
            height: 400,
          },
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'high.risk.table',
                        },
                      },
                    },
                    span: 12,
                  },
                ],
              },
            },
            height: 400,
          },
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'degree.of.change.by.department',
                        },
                      },
                    },
                    span: 12,
                  },
                ],
              },
            },
            height: 400,
          },
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'communications.needed.by.department',
                        },
                      },
                    },
                    span: 12,
                  },
                ],
              },
            },
            height: 400,
          },
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'training.implications.by.department',
                        },
                      },
                    },
                    span: 12,
                  },
                ],
              },
            },
            height: 400,
          },
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'change.impacts.by.epic',
                        },
                      },
                    },
                    span: 12,
                  },
                ],
              },
            },
            height: 400,
          },
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'degree.of.change.by.epic',
                        },
                      },
                    },
                    span: 6,
                  },
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'value.of.change.by.epic',
                        },
                      },
                    },
                    span: 6,
                  },
                ],
              },
            },
            height: 400,
          },
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'change.impacts.by.persona',
                        },
                      },
                    },
                    span: 12,
                  },
                ],
              },
            },
            height: 400,
          },
        ],
      },
    },
    description:
      'Dashboard view for change impact reporting, including change impacts by persona (Change360)',
    name: 'Change Impacts Dashboard',
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
